import { Area, IViolation } from '../../../../models';
import { IOqcValidationError } from '../../../../models/domain/oqc-validation-error';

export abstract class OqcValidation {
  public static validate(
    validationResults: IOqcValidationError[],
    oqcRevisionId?: string
  ): IViolation[] {
    return validationResults.map((x) => ({
      message: x.message,
      pathToViolation: [
        { area: Area.Teamcenter },
        { area: Area.PartDesign, id: oqcRevisionId },
        { area: Area.Oqc, id: `Row ${x.row}` },
      ],
    }));
  }
}
